import { createRouter, createWebHashHistory } from "vue-router";
import Create from "../views/Create.vue";
import Home from "../views/Home.vue";
import Edit from "../views/Edit.vue";

const routes = [
  {
    path: "/",
    name: "List",
    component: Home,
  },
  {
    path: "/create",
    name: "Create",
    component: Create,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin",
    name: "Create",
    component: Create,
    meta: { requiresAuth: true },
  },
  {
    path: "/edit/:id",
    name: "Edit",
    component: Edit,
  },
  {
    path: "/please-log-me-in",
    name: "Login",
    beforeEnter: (to, from, next) => {
      const authObject = {
        auth: true,
        timestamp: new Date().getTime(),
      };
      localStorage.setItem("auth", JSON.stringify(authObject));
      next("/");
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Check if the user is authenticated before each route
// If the user is not authenticated, redirect to the login page
// If the user is authenticated and the authentication was done 1 hour or less prior to the accessing the page
// then continue to the requested route
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const authObject = JSON.parse(localStorage.getItem("auth"));
    if (authObject && authObject.auth && new Date().getTime() - authObject.timestamp < 3600000) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
